import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgLockFilled24 = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-lock-filled-24", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Lock Filled 24 Icon'),
    React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeWidth: 2, d: "M5 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8H5z" }),
    React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M8 7a4 4 0 0 1 8 0v4H8z" }))); };
var Memo = memo(SvgLockFilled24);
export default Memo;
//# sourceMappingURL=LockFilled24.js.map